var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 21,
    viewBox: "0 0 20.5 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-3, .cls-4, .cls-5 {\r\n        stroke: #00b0a9;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1, .cls-5 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2, .cls-4 {\r\n        fill: #00b0a9;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10502",
    "data-name": "Group 10502",
    transform: "translate(-268 -726.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    className: "cls-1",
    d: "M138.17,2.5h-1.86a.294.294,0,0,1-.31-.312V.312A.294.294,0,0,1,136.31,0h1.86a.294.294,0,0,1,.31.312V2.183A.294.294,0,0,1,138.17,2.5Z",
    transform: "translate(140.889 727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    className: "cls-1",
    d: "M137.755,58.529h-2.48a.325.325,0,0,1-.279-.156.285.285,0,0,1,0-.312l1.24-1.871a.318.318,0,0,1,.527,0L138,58.062a.285.285,0,0,1,0,.312A.245.245,0,0,1,137.755,58.529Z",
    transform: "translate(141.717 688.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    className: "cls-2",
    d: "M109.562,31.124a1.562,1.562,0,1,1,1.562-1.562A1.567,1.567,0,0,1,109.562,31.124Z",
    transform: "translate(160 707.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    className: "cls-3",
    d: "M168.266,30.391l-1.875,1.875",
    transform: "translate(119.734 705.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7005-2",
    "data-name": "Path 7005",
    className: "cls-3",
    d: "M166.391,30.391l1.875,1.875",
    transform: "translate(119.734 705.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    className: "cls-3",
    d: "M112,10.387A9.022,9.022,0,0,1,118.448,3.9",
    transform: "translate(157.524 724.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    className: "cls-3",
    d: "M147.5,4a8.942,8.942,0,0,1,6.417,6.456",
    transform: "translate(132.964 724.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(280.352 741.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7006-2",
    "data-name": "Path 7006",
    className: "cls-3",
    d: "M112,3.9a9.022,9.022,0,0,0,6.448,6.487",
    transform: "translate(157.524 735.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7009-2",
    "data-name": "Path 7009",
    className: "cls-3",
    d: "M147.5,10.456A8.942,8.942,0,0,0,153.92,4",
    transform: "translate(132.964 735.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-2",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(280.131 736.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-3",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(281.233 736.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-4",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(269.55 736.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-5",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(270.652 736.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-6",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(270.652 741.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-7",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(270.652 732.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-8",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(280.131 732.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-9",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(275.392 742.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384-10",
    "data-name": "Path 7384",
    className: "cls-4",
    d: "M2.812,0V.624",
    transform: "translate(275.392 730.923)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1830",
    "data-name": "Ellipse 1830",
    className: "cls-2",
    cx: 0.642,
    cy: 0.642,
    r: 0.642,
    transform: "translate(277.576 735.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    className: "cls-5",
    d: "M21.852,3.659a1.645,1.645,0,1,1,1.985,0",
    transform: "translate(255.392 732.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7194",
    "data-name": "Path 7194",
    className: "cls-3",
    d: "M0,0A3.561,3.561,0,0,0,2.56,3.411",
    transform: "translate(281.766 740.335) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    className: "cls-3",
    d: "M2.56,0A3.561,3.561,0,0,1,0,3.411",
    transform: "translate(277.227 740.336) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSi);
export default __webpack_public_path__ + "static/media/totalSI.f7b58ba253990f6012bfa71a07ea83c4.svg";
export { ForwardRef as ReactComponent };